<div class="az-tooltip" [ngClass]="azTooltipPosition">
    <p class="item-tooltip">{{ azTooltipText }}</p>
</div>